<template>
  <div class="text-xs-center">
    <v-snackbar
      :timeout="2000"
      :top="true"
      v-model="successSnack"
      color="success"
    >
      <span>Udało się!</span>
      <!--<v-btn dark flat @click.native="redirectToMainView">Przejdź dalej</v-btn>-->
      <v-btn flat @click.native="successSnack = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <!--Edit template-->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{currentEditTemplate.name}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="setDefaultDrinkForm" v-model="formValid">
            <v-text-field
              v-model="currentEditTemplate.name"
              label="Nazwa szablonu"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model.number="currentEditTemplate.size"
              label="Pojemność (ml)"
              :rules="[rules.required]"
              type="number"
              min="0"
              max="100000"
            >
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="red" @click.native="deleteEditDrinkTemplate(currentEditTemplate)">Usuń</v-btn>
          <v-btn flat color="primary" @click="saveEditDrinkTemplate(currentEditTemplate)" :disabled="!formValid">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--End edit Template-->
    <v-bottom-sheet v-model="sheet">

      <v-btn
        slot="activator"
        color="cyan"
        dark
        bottom
        right
        fixed
        fab
        aria-label="set default drink"
      >
        <v-icon>local_drink</v-icon>
      </v-btn>
      <v-card>
        <v-card-text>
          <v-list>
            <v-subheader>Wybierz napój</v-subheader>
            <add-own-drink v-on:saveOwnDrink="saveOwnDrink" v-on:addOwnDrinkActive="addOwnDrinkActive" v-on:addOwnDrinkSuccess="addOwnDrinkSuccess"></add-own-drink>

            <v-list-tile
              v-for="(drink,id) in availableDrinksSorted"
              :key="id"
              @click="setDefaultDrink(drink.id)"
              avatar
            >
              <v-list-tile-avatar>
                <v-avatar size="32px" tile>
                  <span v-if="drink.id===defaultDrink.id">&#x2713;</span>
                  <v-icon>local_drink</v-icon>
                </v-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ ((drink.name) ? drink.name : drink.size+"ml") }}</v-list-tile-title>
                <v-list-tile-sub-title v-if="drink.name">{{drink.size}}ml</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action class="text-xs-right">
                <v-btn icon ripple @click.native="openEditTemplate(drink)" class="pr-0 mr-0">
                  <v-icon>edit</v-icon>
                </v-btn>
                <!--<v-btn icon @click.native="openEditTemplate(drink)" class="pr-0 mr-0">-->
                <!--<v-icon>delete</v-icon>-->
                <!--</v-btn>-->
              </v-list-tile-action>
            </v-list-tile>

            <!--<edit-drink></edit-drink>-->


          </v-list>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>

</template>

<script>
  import addOwnDrink from '@/components/otherComponents/addOwnDrink'
  import editDrink from '@/components/otherComponents/editDrink'
  import lodash from 'lodash';

  export default {
    name: 'setDefaultDrink',
    components: {addOwnDrink, editDrink},
    props: ['availableDrinks', 'defaultDrink'],
    data() {
      return {
        sheet: false,
        editDialog: false,
        currentEditTemplate: {
          name: "",
          size: 0,
        },
        successSnack: false,
        formValid: true,
        rules: {
          required: value => !!value || 'Niestety, to pole jest wymagane :(',
        }
      }
    },
    computed: {
      availableDrinksSorted() {
        return _.orderBy(this.availableDrinks
          , 'size', 'asc')
      }
    },
    methods: {
      setDefaultDrink(drinkId) {
        this.sheet = false;
        this.$emit('setDefaultDrink', drinkId);
        // this.successSnack = true;
      },
      saveOwnDrink(properties) {
        // console.log("MAMY ZMIANKE")
        // if (this.$refs.setDefaultDrinkForm.validate()) {

        this.$emit('addOwnDrink', properties);


        // console.log(properties)
        // }else{
        //   console.log(properties)
        //   console.log(this.$refs.setDefaultDrinkForm)
        //   console.log(this.$refs.setDefaultDrinkForm.validate())
        //   console.log("niewalidate")
        // }
        // this.successSnack = true;
      },
      openEditTemplate(template) {
        console.log("Open", template)
        this.currentEditTemplate = Object.assign({}, template);
        this.editDialog = true;
      },
      saveEditDrinkTemplate(template) {
        // console.log(this.$refs.form.validate())
        if (this.formValid) {
          this.$emit('saveEditDrinkTemplate', {id: template.id, template: template});
          this.editDialog = false;
          this.successSnack = true;
        }
      },
      deleteEditDrinkTemplate(template) {
        this.$emit('deleteEditDrinkTemplate', {id: template.id});
        this.editDialog = false;
        this.successSnack = true;
      },
      addOwnDrinkActive() {
        this.sheet = false;
      },
      addOwnDrinkSuccess() {
        this.successSnack = true;
      }
    }
  }
</script>

<style>
  .bottom-sheet.dialog {
    overflow: scroll !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/otherComponents/setDefaultDrink.vue